export type Routes = keyof typeof routes;
const routes = {
  areas: 'Bostadsmarknad',
  'housing-coops': 'BRF',
  sales: 'Bostäder',
  projects: 'Bostadsprojekt',
  developers: 'Bostadsutvecklare',
  agencies: 'Mäklarbyråer',
  agents: 'Mäklare',
  estimations: 'Värderingar',
  indices: 'Prisindex',
} as const;

/**
 * Parses Ember route name to application name.
 * @param  {String} routeName  Ember route name.
 * @return {String}       Properly formatted initials.
 */
export const getRouteDisplayName = (routeName: string) => {
  const parentRouteName = routeName.split('.').at(0) as Routes;

  if (!parentRouteName) return '';

  return routes[parentRouteName];
};
